import React from "react";
import "./Roster.css";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ViewListIcon from "@material-ui/icons/ViewList";
import ArtTrackIcon from "@material-ui/icons/ArtTrack";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import TracksView from "./TracksView/TracksView";
import DetailView from "./DetailView/DetailView";
import DayView from "./TracksView/DayView";
import AgendaView from "./AgendaView/AgendaView";
import RosterSectionControl from "./RosterSectionControl";

import {
    setDayRange,
    setSelectedDays,
    openAddParentTrackModal,
    getUsers,
    getMachines,
    getEquipment,
    getUIState,
    setUIState
} from "./redux/actions";
import {
    selectDayRange,
    selectSelectedDays,
    selectWeekCount,
    selectUIState
} from "./redux/selectors";
import moment from "moment";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowForward from "@material-ui/icons/ArrowForward";
import { hot } from "react-hot-loader";
import AddEventModal from "./modals/AddEventModal";
import EditEventModal from "./modals/EditEventModal";
import AddParentTrackModal from "./modals/AddParentTrackModal";
import AddChildTrackModal from "./modals/AddChildTrackModal";
import DeleteTrackModal from "./modals/DeleteTrackModal";
import EditTrackModal from "./modals/EditTrackModal";
import FormGroup from "@material-ui/core/FormGroup";
import Button from "@material-ui/core/Button";
import { getJobpacks } from "./redux/actions";
const styles = theme => ({
    card: {
        maxWidth: 400
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    actions: {
        display: "flex"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto",
        [theme.breakpoints.up("sm")]: {
            marginRight: -8
        }
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    avatar: {
        backgroundColor: red[500]
    }
});

function getWeekDays(weekStart, weekCount) {
    const days = [weekStart];
    for (let i = 1; i < weekCount * 7; i += 1) {
        days.push(
            moment(weekStart)
                .add(i, "days")
                .toDate()
        );
    }
    return days;
}

class Roster extends React.Component {
    constructor(props) {
        super(props);

        props.getJobpacks();
        props.getUsers();
        props.getMachines();
        props.getEquipment();
        props.getUIState();

        this.state = {
            hoverRange: undefined
        };

        this.state = {
            showDetailView: true,
            showAgendaView: true,
            eventsLoaded: false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.weekCount !== this.props.weekCount) {
            const start = moment()
                .startOf("isoWeek")
                .toDate();

            const selectedDays = getWeekDays(start, this.props.weekCount);

            this.props.setSelectedDays(selectedDays);
            this.props.setDayRange(
                selectedDays[0],
                selectedDays[this.props.weekCount * 7 - 1],
                true
            );
        }
    }

    render() {
        const { start, end } = this.props.dayRange;

        const classes = this.props.classes;
        return (
            <React.Fragment>
                <div
                    className="Roster"
                    style={{
                        gridTemplateColumns: this.props.uiState.showAgendaView
                            ? "auto 360px"
                            : "100%",
                        gridTemplateRows: this.props.uiState.showDetailView
                            ? "calc(100% - 320px) 320px"
                            : "100%"
                    }}
                >
                    <Card className="card">
                        <CardHeader
                            title="Tracks"
                            avatar={
                                <Avatar aria-label="Recipe" className={classes.avatar}>
                                    <ViewListIcon />
                                </Avatar>
                            }
                        />
                        <CardContent
                            style={{
                                gridColumnStart: 1,
                                gridColumnEnd: 1,
                                gridRowStart: 2,
                                gridRowEnd: 2,
                                overflow: "scroll",
                                paddingTop: "0",
                                marginTop: "-11px"
                            }}
                            className={"TrackContainer TrackContainer-parent DayTrackContainer"}
                        >
                            <div
                                style={{
                                    gridColumnStart: 2,
                                    gridColumnEnd: 2,
                                    gridRowStart: 1,
                                    gridRowEnd: 1,
                                    margin: "0 auto",
                                    width: "400px"
                                }}
                            >
                                <FormGroup row>
                                    <Button
                                        color="primary"
                                        variant="fab"
                                        mini
                                        onClick={() => {
                                            const result = this.props.selectedDays.map(e => {
                                                return moment(e)
                                                    .add(-7, "days")
                                                    .toDate();
                                            });

                                            this.props.setSelectedDays(result);
                                            this.props.setDayRange(
                                                result[0],
                                                result[this.props.weekCount * 7 - 1],
                                                false
                                            );
                                        }}
                                    >
                                        <ArrowBack />
                                    </Button>
                                    <Typography
                                        variant="headline"
                                        style={{
                                            lineHeight: "1.4em",
                                            padding: "5px"
                                        }}
                                    >
                                        {moment(start)
                                            .format("DD/MM/YYYY")
                                            .toString()}
                                        {"-"}
                                        {moment(end)
                                            .format("DD/MM/YYYY")
                                            .toString()}{" "}
                                    </Typography>
                                    <Button
                                        color="primary"
                                        variant="fab"
                                        mini
                                        onClick={() => {
                                            const result = this.props.selectedDays.map(e => {
                                                return moment(e)
                                                    .add(7, "days")
                                                    .toDate();
                                            });

                                            this.props.setSelectedDays(result);
                                            this.props.setDayRange(
                                                result[0],
                                                result[this.props.weekCount * 7 - 1],
                                                false
                                            );
                                        }}
                                    >
                                        <ArrowForward />
                                    </Button>
                                </FormGroup>
                            </div>
                            <RosterSectionControl
                                showDetailView={this.props.uiState.showDetailView}
                                showAgendaView={this.props.uiState.showAgendaView}
                                setView={(type, value) => {
                                    this.props.setUIState(type, value);
                                }}
                            />

                            <DayView />
                            <div
                                style={{
                                    gridColumnStart: 1,
                                    gridColumnEnd: 3,
                                    gridRowStart: 3,
                                    gridRowEnd: 3,
                                    overflow: "scroll"
                                }}
                            >
                                <TracksView />
                            </div>
                        </CardContent>
                    </Card>
                    {this.props.uiState.showDetailView ? (
                        <Card
                            className="card"
                            style={{
                                gridColumnStart: 1,
                                gridColumnEnd: 1,
                                gridRowStart: 2,
                                gridRowEnd: 2,
                                paddingTop: "15px"
                            }}
                        >
                            <CardHeader
                                title="Detail"
                                avatar={
                                    <Avatar aria-label="Recipe" className={classes.avatar}>
                                        <ArtTrackIcon />
                                    </Avatar>
                                }
                            />
                            <CardContent style={{ marginTop: "-14px" }}>
                                <DetailView />
                            </CardContent>
                        </Card>
                    ) : null}

                    {this.props.uiState.showAgendaView ? <AgendaView /> : null}
                </div>
                <AddEventModal />
                <EditEventModal />
                <AddParentTrackModal />
                <DeleteTrackModal />
                <AddChildTrackModal />
                <EditTrackModal />
            </React.Fragment>
        );
    }
}

export default hot(module)(
    withStyles(styles)(
        connect(
            store => {
                return {
                    dayRange: selectDayRange(store),
                    selectedDays: selectSelectedDays(store),
                    weekCount: selectWeekCount(store),
                    uiState: selectUIState(store)
                };
            },
            {
                setDayRange,
                setSelectedDays,
                openAddParentTrackModal,
                getJobpacks,
                getUsers,
                getMachines,
                getEquipment,
                getUIState,
                setUIState
            }
        )(Roster)
    )
);
